import api from "./AxiosInterceptor";
import { CONSUMER_USER_VALUE_TEXT } from "./CommonServices";
import EndpointService from "./EndpointService";

export const postVerificationMethodService = async (data, action) => {
  const url = EndpointService("verificationMethod").replace("{action}", action);
  const response = await api.post(url, data);
  return response;
};

export const postPasswordService = async (data, action) => {
  const url = EndpointService("password").replace("{action}", action);
  const response = await api.post(url, data);
  return response;
};
export const postUsernameService = async (data, action) => {
  const url = EndpointService("username").replace("{action}", action);
  const response = await api.post(url, data);
  return response;
};

export const postAccountService = async (data) => {
  const url = EndpointService("account").replace(
    "{fpactusertype}",
    CONSUMER_USER_VALUE_TEXT
  );
  const response = await api.post(url, data);
  return response;
};

export const postCreateAccountService = async (data) => {
  const url = EndpointService("createAccount");
  const response = await api.post(url, data);
  return response;
};
